import { Component, OnInit, ChangeDetectorRef, EventEmitter, Output, Input } from '@angular/core';
import { QuizReviewService } from '../../../../user-module/user-dashboard/user-dashboardcards/charts/quiz-review/quiz-review.service';
import { NgbModalRef, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import * as jsPDF from 'jspdf';
import * as _html2canvas from "html2canvas";
const html2canvas: any = _html2canvas;
import * as htmlToImage from 'html-to-image';

declare global {
  interface Window {
    onePageCanvas?: any;
  }
}

// import * as _html2canvas from "html2canvas";
// const html2canvas: any = _html2canvas;

// import jspdf from 'jspdf';

// import * as htmlToImage from 'html-to-image';

@Component({
  selector: 'app-quiz-review',
  templateUrl: './quiz-review.component.html',
  styleUrls: ['./quiz-review.component.scss']
})
export class QuizReviewComponent implements OnInit {

  @Input() userObject: any;
  @Input() lessonObject: any;
  @Input() listOfAttempts: any;

  public quizReviewObject;
  public selectedAttemp:any;
  public modalRef:NgbModalRef;
  public questionType:any;

  constructor(private qiuzeReviewService: QuizReviewService,private modal:NgbActiveModal,
    private cd: ChangeDetectorRef) {}

  ngOnInit() {
    const object= {
      'startDate': this.lessonObject.startDate,
      'endDate':this.lessonObject.endDate?this.lessonObject.endDate:'' ,
      'percentage':this.lessonObject.percentage ,
      'marks':this.lessonObject.marks}
      this.questionType = this.lessonObject.quizQuestionType;
      const launchUrl= this.lessonObject.launchUrl;
      const user ={'userId':this.lessonObject.lessonAttemptUserIdentity.userId}
    this.selectedAttemp=this.lessonObject;
    this.getQuizReview(user,object,launchUrl);
  }



  private getQuizReview(user,quizAttempt,launchUrl) {
    
    this.qiuzeReviewService.getQuizReview(user, quizAttempt, launchUrl).subscribe(
        (res) => {
          this.quizReviewObject = res;
          this.cd.markForCheck();
          this.cd.detectChanges();
        },
        (err) => {
          if(err.status==401){
            this.modalRef.close();
          }
        });
  }

  closeModal(){
    this.modal.dismiss();
  }

changeAttempt(attempt){
  this.quizReviewObject=[];
  const attemptObject= {
    'startDate': attempt.startDate,
    'endDate':attempt.endDate?attempt.endDate:'' ,
    'percentage':attempt.percentage ,
    'marks':attempt.marks}
    const launchUrl= attempt.launchUrl;
    const user ={'userId':attempt.lessonAttemptUserIdentity.userId}
  this.qiuzeReviewService.getQuizReview(user, attemptObject, launchUrl).subscribe(
    (res) => {
      this.quizReviewObject = res;
      this.cd.markForCheck();
      this.cd.detectChanges();
    },(err) => {
      if(err.status==401){
        this.modalRef.close();
      }
    });
}

getString(option) {
  var stringArray = option.split('\n');
  for (let j = 0; j <= stringArray.length - 1; j++) {
    var data: string = stringArray[j];
    var length = data.search(/\S/)
    for (let i = 1; i <= length; i++) {
      stringArray[j] = "&nbsp" + stringArray[j];
    }
  }
  return stringArray;
}

downloadResult() {

 
  let divcontent = document.getElementById('clickbind');

  html2canvas(divcontent, { useCORS: true, allowTaint: true }).then(canvas => {
    let pdf = new jsPDF('p', 'pt', [canvas.width, canvas.height]);
    let imgData = canvas.toDataURL("image/jpeg", 1.0);
    pdf.addImage(imgData, 0, 0, canvas.width, canvas.height);
    let pdfName = Math.floor(Math.random() * 9999999999) + '.pdf';
    pdf.save(pdfName);
  });

  // const div = document.getElementById("html2Pdf");
  // alert(divcontent.scrollHeight+'=='+divcontent.scrollWidth);

  // const options = {background: "white",  scrollX: 0,
  // scrollY: 0,pagesplit: true};

  //   html2canvas(divcontent, options).then((canvas) => {
  //       //Initialize JSPDF
  //       let doc = new jsPDF("p", "mm", "a4");
  //       //Converting canvas to Image
  //       let imgData = canvas.toDataURL("image/PNG");
  //       //Add image Canvas to PDF
  //       doc.addImage(imgData, 'PNG', 20, 20);

  //       let pdfOutput = doc.output();
  //       // using ArrayBuffer will allow you to put image inside PDF
  //       let buffer = new ArrayBuffer(pdfOutput.length);
  //       let array = new Uint8Array(buffer);
  //       for (let i = 0; i < pdfOutput.length; i++) {
  //           array[i] = pdfOutput.charCodeAt(i);
  //       }

  //       //Name of pdf
  //       const fileName = "example.pdf";

  //       // Make file
  //       doc.save(fileName);

  //   });
 



    // let mywindow = window.open('', 'PRINT', 'height=650,width=900,top=100,left=150');

    
    // mywindow.document.write('</head><body >');
    // mywindow.document.write(divcontent);
    // mywindow.document.write('</body></html>');

    // mywindow.document.close(); // necessary for IE >= 10
    // mywindow.focus(); // necessary for IE >= 10*/

    // mywindow.print();


  // var quotes = document.getElementById('clickbind');
  // html2canvas(quotes,{
  //   width: quotes.scrollWidth,
  //   height: quotes.scrollHeight,
  // }).then((canvas) => {
  //       //! MAKE YOUR PDF
  //       var pdf = new jsPDF('p', 'pt', 'letter');

  //       for (var i = 0; i <= quotes.scrollHeight/980; i++) {
  //           //! This is all just html2canvas stuff
  //           var srcImg  = canvas;
  //           var sX      = 0;
  //           var sY      = 980*i; // start 980 pixels down for every new page
  //           var sWidth  = 1412;
  //           var sHeight = 980;
  //           var dX      = 0;
  //           var dY      = 0;
  //           var dWidth  = 900;
  //           var dHeight = 980;

  //           window.onePageCanvas = document.createElement("canvas");
  //           window.onePageCanvas.setAttribute('width', 900);
  //           window.onePageCanvas.setAttribute('height', 980);
  //           var ctx = window.onePageCanvas.getContext('2d');
  //           // details on this usage of this function: 
  //           // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Using_images#Slicing
  //           ctx.drawImage(srcImg,sX,sY,sWidth,sHeight,dX,dY,dWidth,dHeight);

  //           // document.body.appendChild(canvas);
  //           var canvasDataURL = window.onePageCanvas.toDataURL("image/png", 1.0);

  //           var width         = window.onePageCanvas.width;
  //           var height        = window.onePageCanvas.scrollHeight;

  //           //! If we're on anything other than the first page,
  //           // add another page
  //           if (i > 0) {
  //               pdf.addPage(612, 791); //8.5" x 11" in pts (in*72)
  //           }
  //           //! now we declare that we're working on that page
  //           pdf.setPage(i+1);
  //           //! now we add content to that page!
  //           pdf.addImage(canvasDataURL, 'PNG', 20, 40, (width*.62), (height*.62));

  //       }
  //       //! after the for loop is finished running, we save the pdf.
  //       let pdfName = Math.floor(Math.random() *9999999999)+'.pdf';
  //       pdf.save(pdfName);
  // });
    

 

  }

  
}




// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/dashboard/quiz-review/quiz-review.component.ts